import { render, staticRenderFns } from "./cfdeDesign.vue?vue&type=template&id=053214dc&scoped=true"
import script from "./cfdeDesign.vue?vue&type=script&lang=js"
export * from "./cfdeDesign.vue?vue&type=script&lang=js"
import style0 from "./cfdeDesign.vue?vue&type=style&index=0&id=053214dc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053214dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('053214dc')) {
      api.createRecord('053214dc', component.options)
    } else {
      api.reload('053214dc', component.options)
    }
    module.hot.accept("./cfdeDesign.vue?vue&type=template&id=053214dc&scoped=true", function () {
      api.rerender('053214dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/cfdeDesign.vue"
export default component.exports